import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiDelete({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.03952 2.78458C6.19776 2.60373 6.42636 2.5 6.66667 2.5H17.5C18.163 2.5 18.7989 2.76339 19.2678 3.23223C19.7366 3.70107 20 4.33696 20 5V15C20 15.663 19.7366 16.2989 19.2678 16.7678C18.7989 17.2366 18.163 17.5 17.5 17.5H6.66667C6.42636 17.5 6.19776 17.3963 6.03952 17.2154L0.206186 10.5488C-0.0687287 10.2346 -0.0687287 9.76543 0.206186 9.45125L6.03952 2.78458ZM7.04481 4.16667L1.94064 10L7.04481 15.8333H17.5C17.721 15.8333 17.933 15.7455 18.0893 15.5893C18.2455 15.433 18.3333 15.221 18.3333 15V5C18.3333 4.77899 18.2455 4.56702 18.0893 4.41074C17.933 4.25446 17.721 4.16667 17.5 4.16667H7.04481Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.5893 6.91058C15.9148 7.23602 15.9148 7.76366 15.5893 8.08909L10.5893 13.0891C10.2639 13.4145 9.73626 13.4145 9.41083 13.0891C9.08539 12.7637 9.08539 12.236 9.41083 11.9106L14.4108 6.91058C14.7363 6.58514 15.2639 6.58514 15.5893 6.91058Z"
				fill={finalColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.41083 6.91058C9.73626 6.58514 10.2639 6.58514 10.5893 6.91058L15.5893 11.9106C15.9148 12.236 15.9148 12.7637 15.5893 13.0891C15.2639 13.4145 14.7363 13.4145 14.4108 13.0891L9.41083 8.08909C9.08539 7.76366 9.08539 7.23602 9.41083 6.91058Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiDelete;
